import { Box, Checkbox, List, ListItem, ListItemAvatar, ListItemButton, ListItemText } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { setAutocolonItem, setAutocolonSelectItem, setGroupSelectedItem } from 'app/actions/transport';
import { Autosizer, Scrollbar } from 'app/components';
import { TransportCircleIcon, TransportSquareIcon, TransportTriangleIcon } from 'app/icons';
import React, { forwardRef, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FixedSizeList } from 'react-window';
const TransportGroupList = ({ setHaveUpdate }) => {
    const dispatch = useDispatch();
    const { groupItems, groupSearchValue, groupSelectedItem, autocolonSelectedItem } = useSelector((state) => state.transport);
    const sortItems = useMemo(() => {
        const compareFn = (a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: 'base' });
        if (groupSearchValue.length) {
            return [...groupItems]
                .filter((item) => item.name.toLowerCase().indexOf(groupSearchValue.toLowerCase()) !== -1)
                .sort(compareFn);
        }
        return [...groupItems].sort(compareFn);
    }, [groupItems, groupSearchValue]);
    const handleItemClick = (value) => {
        if ((groupSelectedItem === null || groupSelectedItem === void 0 ? void 0 : groupSelectedItem.id) === value.id) {
            dispatch(setGroupSelectedItem(null));
        }
        else {
            dispatch(setGroupSelectedItem(value));
        }
    };
    const handleCheckGroup = (e, group) => {
        e.preventDefault();
        e.stopPropagation();
        if (autocolonSelectedItem === null || autocolonSelectedItem === void 0 ? void 0 : autocolonSelectedItem.autocolons) {
            return;
        }
        setHaveUpdate(true);
        let groupItemIds = (autocolonSelectedItem === null || autocolonSelectedItem === void 0 ? void 0 : autocolonSelectedItem.groupItems) || [];
        if (groupItemIds.includes(group.id)) {
            groupItemIds = groupItemIds.filter((item) => item !== group.id);
        }
        else {
            groupItemIds = [...groupItemIds, group.id];
        }
        const newAutocolonItem = Object.assign(Object.assign({}, autocolonSelectedItem), { groupItems: groupItemIds });
        dispatch(setAutocolonItem(newAutocolonItem));
        dispatch(setAutocolonSelectItem(Object.assign(Object.assign({}, autocolonSelectedItem), { groupItems: groupItemIds })));
    };
    return (React.createElement(Box, { component: 'div', sx: (theme) => ({
            width: '100%',
            height: '100%',
            '.simplebar-offset > div': {
                '&::-webkit-scrollbar': {
                    width: 0,
                },
                '&::-webkit-scrollbar-track': {
                    background: 'transparent',
                    boxShadow: 'none',
                },
                '&::-webkit-scrollbar-thumb': {
                    backgroundColor: 'transparent',
                    boxShadow: 'none',
                },
            },
            '.MuiListItem-root': {
                width: '100%',
                userSelect: 'none',
                padding: theme.spacing(0),
                borderRadius: '0',
                '&:hover': {
                    bgcolor: '#f5f6fa',
                },
                '.MuiCheckbox-root': {
                    '&:hover': {
                        bgcolor: 'transparent',
                    },
                },
                '.MuiListItemAvatar-root': {
                    minWidth: '36px',
                    maxHeight: '24px',
                },
                '.MuiAvatar-circular': {
                    width: '24px',
                    height: '24px',
                    color: theme.palette.primary.main,
                    bgcolor: alpha(theme.palette.primary.main, 0.12),
                    svg: {
                        fontSize: '16px',
                        path: {
                            fill: theme.palette.primary.main,
                        },
                    },
                },
                '.MuiListItemButton-root': {
                    padding: theme.spacing(1, 0),
                    borderRadius: '0',
                    maxHeight: '100%',
                },
                '.MuiListItemText-root': {
                    margin: theme.spacing(0),
                },
                '&.Mui-selected .MuiButtonBase-root.MuiCheckbox-root': {
                    color: theme.palette.common.white,
                },
            },
        }) },
        React.createElement(Autosizer, null, ({ height, width }) => (React.createElement(Box, { sx: { height, width } },
            React.createElement(Scrollbar, null, ({ scrollableNodeRef, contentNodeRef }) => (React.createElement(FixedSizeList, { height: height, itemSize: 36, overscanCount: 10, itemCount: sortItems.length, innerRef: contentNodeRef, outerRef: scrollableNodeRef, innerElementType: transportGroupListInnerElementType, itemData: {
                    items: sortItems,
                    selectedItem: groupSelectedItem,
                    onClick: handleItemClick,
                    autocolonSelectedItem,
                    handleCheckGroup,
                } }, transportGroupListItemRender))))))));
};
const transportGroupListInnerElementType = forwardRef((props, ref) => (React.createElement(List, Object.assign({ ref: ref, disablePadding: true }, props))));
transportGroupListInnerElementType.displayName = 'TransportGroupListInnerElementType';
const transportGroupListItemRender = ({ data, index, style }) => {
    var _a, _b;
    const { items, selectedItem, onClick, autocolonSelectedItem, handleCheckGroup } = data;
    const item = items[index];
    const checked = ((autocolonSelectedItem === null || autocolonSelectedItem === void 0 ? void 0 : autocolonSelectedItem.groupItems) || []).includes(item.id);
    const markerType = String((_a = item.type) !== null && _a !== void 0 ? _a : 'null');
    return (React.createElement(ListItem, { key: item.id, style: style, selected: item.id === (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.id) },
        React.createElement(ListItemButton, { onClick: () => onClick(item) },
            React.createElement(Checkbox, { checked: checked, color: 'primary', disableRipple: true, onClick: (e) => handleCheckGroup(e, item) }),
            React.createElement(ListItemAvatar, null, (_b = {
                circle: React.createElement(TransportCircleIcon, { color: item.color }),
                triangle: React.createElement(TransportTriangleIcon, { color: item.color }),
                square: React.createElement(TransportSquareIcon, { color: item.color }),
                null: React.createElement(TransportCircleIcon, { sx: { opacity: 0 } }),
            }[markerType === 'null' ? 'null' : markerType]) !== null && _b !== void 0 ? _b : React.createElement(TransportCircleIcon, { sx: { opacity: 0 } })),
            React.createElement(ListItemText, { primary: item.name }))));
};
export default TransportGroupList;
